import { render } from "./LandingLogin.vue?vue&type=template&id=2094b591&scoped=true&lang=pug"
import script from "./LandingLogin.vue?vue&type=script&lang=js"
export * from "./LandingLogin.vue?vue&type=script&lang=js"

import "./LandingLogin.vue?vue&type=style&index=0&id=2094b591&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2094b591"]])

export default __exports__